<template>
  <div class="collapseBtn"
       :style="{
            width: isCollapse ? '64px' : '200px',
            height: isCollapse ? '40px' : '40px'
        }">
    <el-button :icon="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"
               class="btn"
               @click="handleChangeCollapse">
    </el-button>
  </div>
</template>
<script>
export default {
  computed: {
    isCollapse () {
      return this.$store.state.index.isCollapse;
    }
  },
  methods: {
    /**
     * 收起还是展开
     */
    handleChangeCollapse () {
      this.$store.commit("INDEX_COLLAPSE", !this.isCollapse);
    }
  }
};
</script>
<style lang="scss">
.collapseBtn {
    position: absolute;
    bottom: 0;
    width: 100%;
    transition: width 300ms;
    .btn {
        width: 100%;
        // background: #22273b;
        background:  $theme-color;
        border: 0;
        border-radius: 0;
        font-size: 20px;
        color: #fff;
        height: 40px;
        &:hover{
          color: #fff;
          // background: #4b5377;
          background:  #f77f34;
        }
    }
}
</style>
